module.exports = __webpack_public_path__ + "img/DW_Ab5.03f8fb12.png";